<template>
  <div class="planification-buttons">
    <router-link
      v-if="buttons.length"
      :to="{ name: routes.PLAN, params: { ...$route.params } }"
      class="planification-buttons__button"
      :class="{ 'is-active': isActiveButton }"
      tag="button"
    >
      {{ labelViewBy }} <strong>{{ name_level1 }}</strong>
    </router-link>

    <router-link
      v-for="{ id, name } in buttons"
      :key="id"
      :to="{ name: routes.TABLE, params: { ...$route.params, id } }"
      class="planification-buttons__button"
      :class="{ 'is-active': id === currentId }"
      tag="button"
    >
      {{ labelViewBy }} <strong>{{ name | translate }}</strong>
    </router-link>

    <button
      @click="exportCsv()"
      class="planification-buttons__button_export"
      
      @mouseover="isActive = true"
      @mouseout="isActive = false"
    >
      <img
        :src="isActive ? '/do-hover-icon.svg' : '/do-icon.svg'"
        style="width: 16px; position: absolute; top: 12px; left: 6px;"
      />
      {{ labelDownload }} <strong>{{ labelData }}</strong>
    </button>
  </div>
</template>


<script>
import { PlansStore } from "../lib/store";
import { translate } from "lib/vue/filters";
import { routes } from "../lib/router";

export default {
  name: "ButtonFilters",
  filters: {
    translate,
  },
  props: {
    options: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      buttons: [],
      labelViewBy:
        I18n.t("gobierto_plans.plan_types.show.view_by") || "",
      labelDownload:
        I18n.t("gobierto_plans.plan_types.show.download_export") || "",
      labelData:
        I18n.t("gobierto_plans.plan_types.show.data_export") || "",
      labelCategory:
        I18n.t("gobierto_plans.plan_types.show.category") || "",
      planId:
        "/plans/" +
        (this.$root?.$data?.planId + "/export_xlsx" || ""),
      isActive: false, // Nueva propiedad para el estado hover
      name_level1: "", // Añadida para evitar error en la asignación
    };
  },
  methods: {
    exportCsv() {
      let route = this.$router.resolve({
        path:
          "/plans/" +
          (this.$root?.$data?.planId + "/export_xlsx" || ""),
      });
      window.open(route.href, "_blank");
    },
  },
  computed: {
    routes() {
      return routes;
    },

    currentId() {
      if (this.$route.name == "plan") {
        return null;
      }
      const { id } = this.$route.params;
      return id;
    },
    isActiveButton() {
      const {
        name: current,
        meta: { button },
      } = this.$route;
      return [current, button].includes(routes.PLAN);
    },
  },
  created() {
    const { meta } = PlansStore.state;
    const { fields_to_show_as_filters = [] } = this.options;
    this.name_level1 =
      this.options.level0.one[I18n.locale].charAt(0).toUpperCase() +
      this.options.level0.one[I18n.locale].slice(1).toLowerCase();

    this.buttons = meta.reduce((acc, { attributes }) => {
      const { uid, field_type, name_translations } = attributes;
      if (
        field_type === "vocabulary_options" &&
        fields_to_show_as_filters.includes(uid)
      ) {
        acc.push({ id: uid, name: name_translations });
      }
      return acc;
    }, []);
  },
};
</script>
